import { render } from "./OurServices.vue?vue&type=template&id=5064db4c"
import script from "./OurServices.vue?vue&type=script&lang=js"
export * from "./OurServices.vue?vue&type=script&lang=js"

import "./OurServices.vue?vue&type=style&index=0&id=5064db4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__